export var TITLE = 'OpenRouter';
export var TEXT_MULTIPLE = 1;
export var SPACE_MULTIPLE = 0.4;
export var COLOR_PRIMARY = '#6566F1';